module.exports = __webpack_public_path__ + "static/Icons_CurrentHO_ReverseMortgage_Large-c38a3902e4de53d38395467b690ef3b0.png";